module.exports = __webpack_public_path__ + "static/media/CatchSurf_Logo2x.5f53843b.png";